// extracted by mini-css-extract-plugin
module.exports = {"container":"legalMentions_container__mpSou","divider":"legalMentions_divider__ExtMP","header":"legalMentions_header__JITNY"};